import { Box, MenuItem, Select, Slider, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useFormFactor } from '@cibo/ui'

import { LandReportViewState } from '../LandReportViewProvider'

interface YearPickerProps extends Pick<LandReportViewState, 'focusYear' | 'setFocusYear'> {
  reportYears?: number[]
}

export const YearPicker = ({ focusYear, reportYears, setFocusYear }: YearPickerProps) => {
  const { isMobile } = useFormFactor()
  const { t } = useTranslation('@cibo/landmanager/LandReport/YearPicker')

  if (!reportYears?.length) {
    return null
  }
  if (reportYears?.length === 1) {
    return (
      <Typography variant="caption" color="text.secondary">
        {t('year')}: {reportYears[0]}
      </Typography>
    )
  }

  if (isMobile) {
    return (
      <Box data-testid="year-picker">
        <Select
          aria-label={t('reportYears')}
          placeholder={t('year')}
          value={focusYear}
          onChange={year => setFocusYear(year.target.value as number)}
          size="small"
        >
          {reportYears.map(year => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </Box>
    )
  } else {
    return (
      <Stack direction="row" spacing={3} alignItems="center" data-testid="year-picker">
        <Typography variant="caption" color="text.secondary">
          {t('year')}
        </Typography>
        <Slider
          aria-label={t('reportYears')}
          step={1}
          min={reportYears[reportYears.length - 1]}
          max={reportYears[0]}
          marks={reportYears.map(year => ({ value: year as number }))}
          value={focusYear}
          onChange={(e, value) => setFocusYear(value as number)}
          track={false}
          valueLabelDisplay="auto"
        />
      </Stack>
    )
  }
}
